module.exports = __webpack_public_path__ + "static/media/chicken.3b9c64b9.png";